import moment from 'moment';
import React, { Component } from 'react';
import UtilityServices from '../../services/axioServices/apiServices/UtilityServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import { CommonValidationMessages } from '../../utils/Messages.js';
import { FinancealYearStartDateEndDate } from '../../utils/FinancialYearStartDateEndDate.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';

class UserLog extends Component {
    constructor(props) {
        super(props);
        this.utilityServices = new UtilityServices();
        this.SwalServices = new SwalServices();
        this.state = {
            tableStatus: "",
            filterDetails: {
                startDate: "",
                endDate: ""
            },
            userLogList: [],
            totalCount: 0,
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        let dates = FinancealYearStartDateEndDate()
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = dates.startDate
        filterDetails.endDate = dates.endDate
        this.setState({ filterDetails: filterDetails })
    }
    getAllUserLog = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ tableStatus: "Loading..." }, () => {
                let request = this.state.filterDetails
                let authDetails = getAuthProps()
                request.companyId = authDetails.companyId
                this.utilityServices.getAllUserLog(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                        this.setState({ userLogList: response.responseData, totalCount: response.responseData.length })
                    } else {
                        this.setState({ tableStatus: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        }
    }
    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.startDate = ""
        Fdetails.endDate = ""
        this.setState({
            filterDetails: Fdetails, totalCount: 0, userLogList: []
        });
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details },
        );

    };


    render() {
        return (
            <div className='userLog-page'>

                <div className="item-search flex gap-2.5 !mb-3">
                    <div className="input-grp w-full" >
                        <label>Start Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")
                            }

                        />

                    </div>
                    <div className="input-grp w-full">
                        <label>End Date</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                            type="date"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            value={this.state.filterDetails.endDate}
                            onChange={(event) =>
                                this.handleChange(event, "endDate")
                            }

                        />

                    </div>



                    <div className="btn-grp mt-auto">
                        <button className="add-btn mt-auto" onClick={() => this.getAllUserLog()}>Search</button>
                        <button className="cancel-btn mt-auto" onClick={() => this.resetForm()}>Cancel</button>

                    </div>
                </div>
                <div className="table-upper mt-2.5">
                    <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
                        Total Count :- {this.state.totalCount ? this.state.totalCount : 0}
                    </p>
                </div>
                <div class="item-listing">
                    <div class="itemList-table">
                        <div class="table-container" style={{ height: "calc(100vh - 150px)" }} >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[10%]'>Sr No.</td>
                                        <td className='w-[25%]'>User Name</td>
                                        <td className='w-[25%]'>Email</td>
                                        <td className='w-[20%]'>Login Date</td>
                                        <td className='w-[20%]'>Login Time</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.userLogList && this.state.userLogList.length > 0 ? (
                                        this.state.userLogList.map((details, key) => (
                                            <tr
                                                key={key}
                                            >
                                                <td>{key + 1}</td>
                                                <td>{details.userName}</td>
                                                <td>{details.email}</td>
                                                <td>{moment(details.createdAt).format('DD/MM/YYYY')}</td>
                                                <td>{moment(details.createdAt).format('hh:mm A')}</td>
                                            </tr>
                                        ))
                                    ) : this.state.userLogList &&
                                        this.state.userLogList.length === 0
                                        && this.state.tableStatus !== "" ? (
                                        <tr>
                                            <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {this.state.tableStatus}
                                            </td>
                                        </tr>
                                    ) : this.state.userLogList &&
                                        this.state.userLogList.length === 0
                                        && this.state.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default UserLog;